import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Row, Col } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk} from '@fortawesome/free-solid-svg-icons';
import FormFieldError from 'src/components/general/FormFieldError';
import moment from 'moment';
import { number, numberAbbreviation, date } from 'src/utils/label';
import { tryListServicesByUserAndExercise } from "src/redux/administrativeService/administrativeServiceActionCreator";
import { tryGetListUserProfile } from 'src/redux/user/userActionCreator';
import { getEmail } from 'src/redux/login/loginReducer';
import { getUserListData } from 'src/redux/user/userReducer';
import { getGlobalDataSelectedPeriod } from 'src/redux/globalData/globalDataReducer';
import NumberFormat from 'react-number-format';
import InputCuitForm from 'src/components/common/InputCuitForm';
import InputOrganismForm from 'src/components/common/InputOrganismForm';
import InputServiceForm from 'src/components/common/InputServiceForm';
import InputLegalInstrumentForm from 'src/components/common/InputLegalInstrumentForm';

const ProvisionOrderForm = ({ provisionOrder }) => {
    const dispatch = useDispatch();
    const { register, errors } = useFormContext();
    const [formData, setFormData] = useState({
        administrativeServiceId: provisionOrder?.administrativeServiceId || '',
        orderNumber: provisionOrder?.number || '',
        acquisitionType: provisionOrder?.acquisitionType || '',
        adquisitionDate: provisionOrder?.adquisitionDate || '',
        initiatorText: provisionOrder?.initiator || '',
        destinationText: provisionOrder?.destination || '',
        deliveryPlaceText: provisionOrder?.deliveryLocation || '',
        denominationText: '',
        validExpedient: false,
        organismCode: provisionOrder?.administrativeDocument?.codeOrganism || '',
        organismNumber: provisionOrder?.administrativeDocument?.number || '',
        organismYear: provisionOrder?.administrativeDocument?.year || '',
        validLegalInstrument: false,
        legalInstrumentType: provisionOrder?.legalInstrument?.legalInstrumentType?.name || '',
        legalInstrumentNumber: provisionOrder?.legalInstrument?.number || '',
        legalInstrumentYear: provisionOrder?.legalInstrument?.year || '',
        legalInstrumentDate: provisionOrder?.legalInstrument?.date || '',
        deadlineAmount: provisionOrder?.deadlineAmount || '',
        deadlineTimeType: provisionOrder?.deadlineTimeType || ''
    });

    // Validations messages
    const whiteSpaceError = 'El campo contiene solo espacios en blanco. Ingrese un texto válido.'
    const numberRequiredMsg = 'Debe ingresar un número';
    const dateRequiredMsg = 'Debe ingresar una fecha dentro del periodo';
    const initiatorRequiredMsg = 'Debe ingresar el iniciador.'
    const destinationRequiredMsg = 'Debe ingresar el destino.'
    const deliveryPlaceRequiredMsg = 'Debe ingresar el lugar de entrega.'
    const amountRequiredMsg = 'Debe ingresar la Cantidad.'
    const deadlineTimeTypeMsg = 'Debe ingresar Día / Días hábiles / Semana / Mes'
    const acquisitionTypeMsg = 'Debe seleccionar el tipo de contratación'
    const numberValidationObj = { required: numberRequiredMsg };
    const dateValidationObj = { required: dateRequiredMsg };
    const initiatorValidationObj = { required: initiatorRequiredMsg, validate: value => validateWhiteSpaces(value) ? whiteSpaceError : null };
    const destinationValidationObj = { required: destinationRequiredMsg, validate: value => validateWhiteSpaces(value) ? whiteSpaceError : null };
    const deliveryPlaceValidationObj = { required: deliveryPlaceRequiredMsg, validate: value => validateWhiteSpaces(value) ? whiteSpaceError : null };
    const amountValidationObj = { required: amountRequiredMsg };
    const deadlineTimeTypeObj = { required: deadlineTimeTypeMsg };
    const acquisitionTypeObj = { required: acquisitionTypeMsg}
    const engagementValidationObj = { required: false };

    // Validations
    const todayDate = moment(new Date()).format('YYYY-MM-DD');
    const validateWhiteSpaces = (value) => {
        if (value?.trim() == '') {
            return true;
        } else {
            return false;
        };
    };
    const withValueLimit = (inputObj) => {
        const { value } = inputObj;
        const maxValue = 9999;
        if (value <= maxValue)
            return inputObj;
    };

    // User data
    const listUserData = useSelector(state => getUserListData(state));
    const email = useSelector(state => getEmail(state));
    const userFound = listUserData?.records?.find(item => item?.email == email);
    const globalSelectedPeriod = useSelector(state => getGlobalDataSelectedPeriod(state));
    const engagement = [
        {
            id: 1,
            displayName: 'Contratacion directa art 3ro',
            name: 'CONTRATACION_DIRECTA_ART_3RO'
        },
        {
            id: 2,
            displayName: 'Compra directa',
            name: 'COMPRA_DIRECTA'
        },
        {
            id: 3,
            displayName: 'Concurso de precios',
            name: 'CONCURSO_DE_PRECIOS'
        },
        {
            id: 4,
            displayName: 'Contado contra entrega',
            name: 'CONTADO_CONTRA_ENTREGA'
        },
        {
            id: 5,
            displayName: 'Contratacion directa',
            name: 'CONTRATACION_DIRECTA'
        },
        {
            id: 6,
            displayName: 'Contrato',
            name: 'CONTRATO'
        },
        {
            id: 7,
            displayName: 'Licitacion privada',
            name: 'LICITACION_PRIVADA'
        },
        {
            id: 8,
            displayName: 'Licitacion publica',
            name: 'LICITACION_PUBLICA'
        }
    ];
    function getNames(engagementArray) {
        return engagementArray.map(item => item.name);
    }
    const engagementList = getNames(engagement);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };
    const handleAdministrativeService = value => { delete errors?.administrativeServiceId; handleChange('administrativeServiceId', value) }
    const handleOrderNumber = value => handleChange('orderNumber', value)
    const handleAdquisitionDate = value => handleChange('adquisitionDate', value)
    const handleAdquisitionType = value => handleChange('acquisitionType', value)
    const handleOrganismCode = value => handleChange('organismCode', value)
    const handleOrganismNumber = value => handleChange('organismNumber', value)
    const handleOrganismYear = value => handleChange('organismYear', value)
    const handleIniciatorText = value => handleChange('initiatorText', value)
    const handleDestinationText = value => handleChange('destinationText', value)
    const handleDeliveryPlaceText = value => handleChange('deliveryPlaceText', value)
    const handleLegalInstrumentType = value => handleChange('legalInstrumentType', value)
    const handleLegalInstrumentNumber = value => handleChange('legalInstrumentNumber', value)
    const handleLegalInstrumentYear = value => handleChange('legalInstrumentYear', value)
    const handleLegalInstrumentDate = value => handleChange('legalInstrumentDate', value)
    const handleDeadlineAmount = value => handleChange('deadlineAmount', value)
    const handleDeadlineTimeType = value => handleChange('deadlineTimeType', value)


    useEffect(() => {
        dispatch(tryGetListUserProfile());
        dispatch(tryListServicesByUserAndExercise(userFound?.id, globalSelectedPeriod?.id));
    }, []);

    return <>
        <InputServiceForm formData={formData} handleAdministrativeService={handleAdministrativeService} />
        <Form.Group as={Row}>
            <Form.Label htmlFor='number' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                {number}:
            </Form.Label>
            <Col sm='4'>
                <div className="input-group">
                    <NumberFormat
                        name='orderNumber'
                        value={formData?.orderNumber}
                        decimalScale={0}
                        inputMode='numeric'
                        className="form-control mr-2"
                        placeholder={numberAbbreviation}
                        allowNegative={false}
                        allowLeadingZeros={false}
                        isAllowed={(inputObj) => withValueLimit(inputObj)}
                        getInputRef={register(numberValidationObj)}
                        onChange={e => handleOrderNumber(e?.target?.value)}
                    />
                    <Form.Control
                        type='number'
                        name='fiscalYearId'
                        value={globalSelectedPeriod?.year}
                        ref={register}
                        id='globalSelectedPeriod'
                        readOnly
                    />
                </div>
                <FormFieldError errors={errors?.orderNumber} />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Fecha de orden de provisión:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='date'
                    name='orderDate'
                    ref={register(dateValidationObj)}
                    max={todayDate}
                    value={provisionOrder?.adquisitionDate}
                    onChange={e => handleAdquisitionDate(e?.target?.value)}
                />
                <FormFieldError errors={errors?.orderDate} />
            </Col>
        </Form.Group>
        <InputOrganismForm formData={formData} handleOrganismCode={handleOrganismCode} handleOrganismNumber={handleOrganismNumber} handleOrganismYear={handleOrganismYear} />
        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Iniciador:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='text'
                    name='initiator'
                    value={formData?.initiatorText}
                    placeholder='Ingresar Iniciador'
                    onChange={e => handleIniciatorText(e?.target?.value)}
                    ref={register(initiatorValidationObj)}
                    maxLength="255"
                />
                <FormFieldError errors={errors?.initiator} />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Destino:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='text'
                    name='destination'
                    value={formData?.destinationText}
                    placeholder='Ingresar Destino'
                    onChange={e => handleDestinationText(e?.target?.value)}
                    ref={register(destinationValidationObj)}
                    maxLength="255"
                />
                <FormFieldError errors={errors?.destination} />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Lugar de entrega:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='text'
                    name='deliveryPlace'
                    value={formData?.deliveryPlaceText}
                    placeholder='Ingresar Lugar de Entrega'
                    onChange={e => handleDeliveryPlaceText(e?.target?.value)}
                    ref={register(deliveryPlaceValidationObj)}
                    maxLength="255"
                />
                <FormFieldError errors={errors?.deliveryPlace} />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Plazo de Entrega:
            </Form.Label>
            <Col sm='4'>
                <div className="input-group" >
                    <Form.Control
                        type='text'
                        name='deadlineAmount'
                        value={formData?.deadlineAmount}
                        className='mr-2'
                        placeholder='Cantidad'
                        maxLength="10"
                        onChange={e => handleDeadlineAmount(e.target.value)}
                        ref={register(amountValidationObj)}
                    />
                    <Form.Control
                        name='deadlineTimeType'
                        value={formData?.deadlineTimeType}
                        type='text'
                        className="form-control"
                        placeholder={'Dias, Semanas, Mes'}
                        onChange={e => handleDeadlineTimeType(e.target.value)}
                        ref={register(deadlineTimeTypeObj)}
                    />
                </div>
                <FormFieldError errors={errors?.deadlineAmount} />
                <FormFieldError errors={errors?.deadlineTimeType} />
            </Col>
        </Form.Group>
        <Form.Group as={Row}>
            <Form.Label className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Contratación:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    as='select'
                    className='select-min-width mr-1'
                    value={formData?.acquisitionType}
                    onChange={e => handleAdquisitionType(e?.target?.value)}
                >
                    <option value={undefined} selected>Seleccione una opción...</option>
                    {engagementList?.map(item => (
                        <option value={item}>
                            {item.replace(/_/g, ' ')}
                        </option>))
                    }
                </Form.Control>
                <FormFieldError errors={errors?.acquisitionType} />
                <Form.Control hidden ref={register(acquisitionTypeObj)} name='acquisitionType' value={formData?.acquisitionType} />
            </Col>
        </Form.Group>
        <InputCuitForm inputName={'Proveedor: '} provider={provisionOrder?.beneficiary} />
        <InputLegalInstrumentForm legalInstrument={formData} handleLegalInstrumentType={handleLegalInstrumentType} handleLegalInstrumentNumber={handleLegalInstrumentNumber} handleLegalInstrumentYear={handleLegalInstrumentYear} />
        <Form.Group as={Row}>
            <Form.Label htmlFor='asunto' className='text-right d-flex mandatory-label' column sm='4'>
                <FontAwesomeIcon icon={faAsterisk} size='xs' className='mr-1 text-danger mandatory-asterisk' />
                Fecha del instrumento legal:
            </Form.Label>
            <Col sm='4'>
                <Form.Control
                    type='date'
                    name='legalInstrumentDate'
                    ref={register(dateValidationObj)}
                    max={todayDate}
                    value={formData?.legalInstrumentDate}
                    onChange={e => handleLegalInstrumentDate(e.target.value)}
                />
                <FormFieldError errors={errors?.legalInstrumentDate} />
            </Col>
        </Form.Group>
    </>
};

export default ProvisionOrderForm;